// extracted by mini-css-extract-plugin
export default {"button":"tj-z","reviewSort":"uj-z"};